<section id="homeMain" aria-labelledby="main-section-title">
    <div class="home-main">
      <article class="flex-1">
        <h2 class="section-title__head mb-3" id="main-section-title">
          <span class="home-main-2">{{ 'home.home_main_new_title' | translate }} </span>
          <app-typewriter [text]="'home.home_main_new_subtitle' | translate"></app-typewriter>
        </h2>

        <p class="section-title__head__subtitle home-main-4"
          [innerHTML]="'home.home_main_new_desc' | translate | safeHtml">
        </p>
      </article>
    </div>
  
</section>